<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="List Bullet" class="d-icon d-icon--list-bullet" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.704 4.865a1.245 1.245 0 0 1 1.092 0 1.25 1.25 0 1 1-1.092 0ZM4.5 2.682a.5.5 0 0 0 .5.5h5.5a.5.5 0 1 0 0-1H5a.5.5 0 0 0-.5.5ZM1.704 3.806a1.25 1.25 0 1 1 1.093-2.249 1.25 1.25 0 0 1-1.093 2.25ZM4.5 9.318a.5.5 0 0 1 .5-.5h5.5a.5.5 0 1 1 0 1H5a.5.5 0 0 1-.5-.5ZM1.734 8.18a1.25 1.25 0 1 0 1.033 2.277A1.25 1.25 0 0 0 1.734 8.18ZM4.5 5.99a.5.5 0 0 0 .5.5h5.5a.5.5 0 1 0 0-1H5a.5.5 0 0 0-.5.5Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconListBullet',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
